import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Tag, Button, Space, Col, Spin } from 'antd';

import { AuthorAdditionalInfo, getAuthorInfo } from '../api/Author';
import { getDisplayName } from './shared';

interface IAuthorInfoDisplay {
    id: string;
    _authorInfo?: AuthorAdditionalInfo;
    hideAdditionalInfo?: boolean;
}

export const AuthorInfoDisplay = (props: IAuthorInfoDisplay) => {
    const { id, _authorInfo, hideAdditionalInfo } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [authorInfo, setAuthorInfo] = useState<AuthorAdditionalInfo>();
    const location = useLocation();
    useEffect(() => {
        if (_authorInfo) {
            setAuthorInfo(_authorInfo);
        } else {
            setLoading(true);
            const queryParams = new URLSearchParams(location.search);
            const year = queryParams.get('year') || '2017'; // TODO: don't hard code year
            getAuthorInfo(id, year).then((response) => {
                setAuthorInfo(response);
                setLoading(false);
            });
        }
    }, [id, location, _authorInfo]);

    return (
        <Container>
            {loading ? (
                <span>
                    <Spin /> Loading…
                </span>
            ) : null}
            {!loading && authorInfo ? (
                <div>
                    <Space>
                        <Name>{getDisplayName(authorInfo)}</Name>
                        <Button size="small" href={authorInfo.url} target="_blank" rel="noreferrer">
                            View in Semantic Scholar
                        </Button>
                    </Space>
                    {authorInfo.affiliations && authorInfo.affiliations.length ? (
                        <p>Affiliation(s): {authorInfo.affiliations.join(', ')}</p>
                    ) : null}
                    {!hideAdditionalInfo ? (
                        <React.Fragment>
                            {!authorInfo.personaIdx ? (
                                <React.Fragment>
                                    <Col span={24}>
                                        {authorInfo.paperCount ? (
                                            <p>
                                                Number of papers:{' '}
                                                {authorInfo.paperCount.toLocaleString()}
                                            </p>
                                        ) : null}
                                    </Col>
                                    <Col span={24}>
                                        {authorInfo.citationCount ? (
                                            <p>
                                                Number of citations:{' '}
                                                {authorInfo.citationCount.toLocaleString()}
                                            </p>
                                        ) : null}
                                    </Col>
                                </React.Fragment>
                            ) : null}
                            {authorInfo.task && authorInfo.task.length ? (
                                <p>
                                    Tasks:{' '}
                                    {authorInfo.task.map((term) => (
                                        <Tag key={term} color="purple">
                                            {term}
                                        </Tag>
                                    ))}
                                </p>
                            ) : null}
                            {authorInfo.method && authorInfo.method.length ? (
                                <p>
                                    Methods:{' '}
                                    {authorInfo.method.map((term) => (
                                        <Tag key={term} color="blue">
                                            {term}
                                        </Tag>
                                    ))}
                                </p>
                            ) : null}
                        </React.Fragment>
                    ) : null}
                </div>
            ) : null}
        </Container>
    );
};

const Name = styled.h4`
    margin: ${({ theme }) => `${theme.spacing.lg} ${theme.spacing.xs} ${theme.spacing.lg} 0`};
`;

const Container = styled.div`
    min-height: 30px;
`;
